import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) 1985",
    correct: false,
  },
  {
    option: "b) 1986",
    correct: false,
  },
  {
    option: "c) 1987",
    correct: true,
  },
  {
    option: "d) 1988",
    correct: false,
  },
];

export default function Question6(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question6: {
          title: "Em que ano foi fundado o Grupo Stefanini ?",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div className="div-question">
      <h5 style={{ textAlign: "center" }}>
        {t("Em que ano foi fundado o Grupo Stefanini ?")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
